export type VatImportScope = 'fiscal_year' | 'period' | 'latest_only';

export class VatImportSettings {
    reverseVatSaldoOrder = false;
    importScope: VatImportScope = 'fiscal_year';
    automaticVatImport = false;

    deserialize(data: any): this {
        this.reverseVatSaldoOrder = data?.reverse_vat_saldo_order ?? false;
        this.importScope = data?.import_scope ?? 'fiscal_year';
        this.automaticVatImport = data?.automatic_vat_import ?? false;
        return this;
    }

    serialize(): any {
        return {
            'reverse_vat_saldo_order': this.reverseVatSaldoOrder,
            'import_scope': this.importScope,
            'automatic_vat_import': this.automaticVatImport,
        };
    }
}
